import { useEffect } from 'react';
import { keywordsType, keywordType } from '../stores/KeywordStore';
import { cleanString } from '../util/renderHelpers';

export const useKeywordsDefinition = (
  ref: any,
  keywords: keywordsType | null,
  displayContent: JSX.Element | JSX.Element[],
  classTrigger: string = '.keyword_def'
) => {
  const addToolTip = (word: HTMLElement, keywordData: keywordType) => (e: any) => {
    if (!word.querySelector('.keyword-definition')) {
      // Dynamic position of tooltip future worek improve this
      let toolTipWidth = 320;

      const windowWidth = window.innerWidth;
      const wordWidth = word.getBoundingClientRect().width;
      const wordLeft = word.getBoundingClientRect().left;
      const wordRight = word.getBoundingClientRect().right;
      const wordTop = word.getBoundingClientRect().top;

      const left =
        windowWidth - toolTipWidth < 0
          ? '50%'
          : wordRight + toolTipWidth > windowWidth
          ? `${wordLeft - (wordRight + toolTipWidth - windowWidth)}px`
          : `${wordLeft - 20}px`;

      const translateX = windowWidth - toolTipWidth < 0 ? '-50%' : '0px';

      toolTipWidth = windowWidth - toolTipWidth < 0 ? windowWidth - 20 : toolTipWidth;

      document.body.insertAdjacentHTML(
        'beforeend',
        `<span class="keyword" id="keyword-definition" style="top:${wordTop}px;"><span data-id="${
          keywordData.keywordId
        }" style="left:${left};width:${toolTipWidth}px;transform:translateX(${translateX});" class="keyword-definition"><span class="keyword-definition__name">${cleanString(
          keywordData.keywordName
        )}</span><span class="keyword-definition__definition">${cleanString(
          keywordData.keywordDef
        )}</span></span><span class="keyword-definition__arrow" style="left:${wordLeft +
          wordWidth / 2 -
          10}px;"></span></span>`
      );
    }
  };

  const removeToolTip = (word: HTMLElement) => () => {
    const thisToolTip = document.body.querySelector('#keyword-definition');
    if (word && thisToolTip) {
      document.body.removeChild(thisToolTip);
    }
  };

  useEffect(() => {
    const content = ref.current;
    const findWords: HTMLElement[] = Array.from(content.querySelectorAll(classTrigger));
    if (findWords.length > 0 && keywords) {
      findWords.forEach((word: HTMLElement) => {
        word.tabIndex = 0;
        const keywordData = keywords[word.innerHTML.trim().toUpperCase()];
        if (keywordData) {
          word.addEventListener('mouseenter', addToolTip(word, keywordData));
          word.addEventListener('mouseleave', removeToolTip(word));
          word.addEventListener('focus', addToolTip(word, keywordData));
          word.addEventListener('blur', removeToolTip(word));

          return () => {
            word.removeEventListener('mouseenter', addToolTip(word, keywordData));
            word.addEventListener('mouseleave', removeToolTip(word));
            word.removeEventListener('focus', addToolTip(word, keywordData));
            word.removeEventListener('blur', removeToolTip(word));
          };
        }
      });
    }
  }, [ref, classTrigger, keywords, displayContent]);
};
